import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import loadingReducer from "./loadingSlice";
import formReducer from "./form/formSlice";
import organizationSetupSlice from "./OrganizationSetup/organizationSetupSlice";
import viewFormReducer from "./ViewForm/viewFormSlice";
import managedFormsReducer from "./ManageForms/managedFormsSlice";
import profileSlice from "./ProfileSlice/profileSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    form: formReducer,
    orgSetup: organizationSetupSlice,
    viewForm: viewFormReducer,
    managedForms: managedFormsReducer,
    profile: profileSlice,
  },
});
